
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { TotemModel } from '../../../models/application/totem/totem';

@Injectable()
export class StructureTotemEditProvider implements Resolve<any> {
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    totem: TotemModel;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getTotem()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getTotem(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data = this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.totem = data;
                this.onDataChanged.next(this.totem);
                resolve(this.totem);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('totem/' + this.routeParams.id).subscribe({
                    next: (res: TotemModel) => {
                        this.totem = res;
                        this.onDataChanged.next(this.totem);
                        resolve(res);
                    }, error: (err: any) => { reject(err) }
                });
            }
        });
    }

    insert(totem): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('totem/', totem).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    edit(totem): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('totem/', totem).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    delete(totem): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('totem/' + totem.id).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    checkLastModifications(): TotemModel {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked) {
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }
        return data;
    }

    generatePassWord(totem): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('totem/generate-password', totem).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    callPassword(scheduleCallId, environmentId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put(`totem/call-password/${scheduleCallId}/${environmentId}`).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    callOldPassword(totemControl): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`totem/call-old-password/`, totemControl).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    cancelPassword(scheduleCallId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put(`totem/cancel-password/${scheduleCallId}`).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                }, error: (err: any) => { reject(err) }
            });
        });
    }
}
